<template lang="pug">
.input-text
  label.input-text__label(for="field-login-phone") Phone *
  input.input-text__input(
    id="field-login-phone"
    type="tel"
    placeholder=""
    v-model.trim="value"
    @change="changeFieldValue()"
    @keyup="changeFieldValue()"
    v-maska="['+1 (###) ###-####', '+1 (###) ###-####']"
  )
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FieldPhone',

  data () {
    return {
      value: ''
    }
  },

  methods: {
    ...mapMutations([
      'changeField'
    ]),

    changeFieldValue () {
      this.changeField({
        name: 'fieldPhone',
        value: this.value
      })
    }
  }
}
</script>
